(() => {
  if (window.__yesArtYesFunnelFixes) return;
  window.__yesArtYesFunnelFixes = true;

  const productFormSelector = 'form[action*="/cart/add"]';
  const preferredSquareSizes = ['20x20', '24x24', '30x30', '32x32', '36x36', '16x16', '14x14', '12x12', '10x10'];
  let defaultSizeLocked = false;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function cleanText(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function isProductPage() {
    return location.pathname.indexOf('/products/') !== -1 && document.querySelector(productFormSelector);
  }

  function injectStyles() {
    if (document.getElementById('yay-funnel-fixes-style')) return;

    const style = document.createElement('style');
    style.id = 'yay-funnel-fixes-style';
    style.textContent = `
      .product__info-container .product-form__quantity {
        display: none !important;
      }

      .yay-most-popular-badge {
        display: inline-block;
        margin-left: 0.6rem;
        padding: 0.25rem 0.7rem;
        border-radius: 999px;
        background: #111111;
        color: #ffffff;
        font-size: 1.1rem;
        line-height: 1;
        font-weight: 700;
        white-space: nowrap;
        vertical-align: middle;
      }
    `;
    document.head.appendChild(style);
  }

  function normalizeSizeNumber(value) {
    return String(Number(value));
  }

  function squareSizeFromText(value) {
    const match = value.toLowerCase().match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*inch/);
    if (!match) return null;

    const width = Number(match[1]);
    const height = Number(match[2]);
    if (!Number.isFinite(width) || !Number.isFinite(height)) return null;
    if (Math.abs(width - height) > 0.01) return null;

    return normalizeSizeNumber(match[1]) + 'x' + normalizeSizeNumber(match[2]);
  }

  function labelForInput(input, fieldset) {
    return Array.from(fieldset.querySelectorAll('label')).find((label) => label.htmlFor === input.id || label.contains(input));
  }

  function getSizeFieldset() {
    return Array.from(document.querySelectorAll('fieldset')).find((fieldset) => {
      const legend = fieldset.querySelector('legend');
      return /size/i.test(cleanText(legend)) && fieldset.querySelector('input[type="radio"]');
    });
  }

  function addMostPopularBadge(label) {
    if (!label || label.querySelector('.yay-most-popular-badge')) return;

    const badge = document.createElement('span');
    badge.className = 'yay-most-popular-badge';
    badge.textContent = 'Most popular';
    label.appendChild(badge);
  }

  function selectPreferredSquareSize() {
    if (defaultSizeLocked) return;
    if (new URLSearchParams(location.search).has('variant')) return;

    const fieldset = getSizeFieldset();
    if (!fieldset) return;

    const options = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
      .map((input) => {
        const label = labelForInput(input, fieldset);
        return {
          input,
          label,
          size: squareSizeFromText(cleanText(label)),
        };
      })
      .filter((option) => option.label && option.size);

    if (options.length < 4) return;

    const target = preferredSquareSizes
      .map((size) => options.find((option) => option.size === size))
      .find(Boolean);

    if (!target) return;

    defaultSizeLocked = true;
    addMostPopularBadge(target.label);

    if (!target.input.checked) {
      target.label.click();
      target.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function forceQuantityOne() {
    document.querySelectorAll(`${productFormSelector} input[name="quantity"]`).forEach((input) => {
      input.value = '1';
    });
  }

  ready(() => {
    if (!isProductPage()) return;

    document.body.classList.add('yay-product-page');
    injectStyles();
    forceQuantityOne();

    document.addEventListener('change', forceQuantityOne, true);
    window.setTimeout(selectPreferredSquareSize, 400);
    window.setTimeout(selectPreferredSquareSize, 1200);
  });
})();